import React, { Dispatch, useEffect, useState } from 'react';
import { Button, Radio } from '@mui/material';
import { makeStyles } from '@mui/styles';

import classes from './configDialog.module.scss';
import { ReactComponent as Exit } from '../../assets/images/exitEmployeeTable.svg';
import { TypeModalWindow } from '../../types/utils/constants';

type Config = {
  state: boolean;
  type: number;
};
type props = {
  setConfig: Dispatch<Config>;
  config: Config;
  // logsInfo: LogsInfo;
  // handleUpdateEntity(entityId: number, type: number): Promise<void>;
};

const useStyles = makeStyles({
  root: {
    background: 'none',
    borderRadius: 0,
    width: 160,
    color: '#FF7221',
    textTransform: 'none',
    '&:hover, &:focus': {
      background: '#DE6109',
      color: 'white',
    },
    fontFamily: 'HelveticaNeueCyr',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    height: 38,
    fontSize: 14,
    padding: '0 30px',
  },
});

export const ConfigDialog = ({ setConfig, config }: props) => {
  const style = useStyles();
  const [checked, setChecked] = useState(false);

  return (
    <>
      <div className={classes.container}>
        <div className={classes.container__title}>
          <p>
            Конфигурация полей
            {config.type === TypeModalWindow.ORGANIZATION_DIALOG
              ? ' организации'
              : null}{' '}
            {config.type === TypeModalWindow.SUBDIVISION_DIALOG
              ? ' подразделения'
              : null}
            {config.type === TypeModalWindow.CONFIG_DIALOG
              ? ' сотрудника'
              : null}
          </p>
          <Exit
            onClick={() =>
              setConfig({
                type: TypeModalWindow.ORGANIZATION_DIALOG,
                state: false,
              })
            }
          />
        </div>
        <div className={classes.container__content__title}>
          <p>Выберите поля для редактирования</p>
        </div>
        <div className={classes.container__content__row}>
          <p>Уникальный идентификатор</p>
          <div className={classes.container__content__row__radio}>
            <Radio
              checked={checked}
              onChange={() => setChecked(!checked)}
              value="out"
              name="radio-button-demo"
              inputProps={{ 'aria-label': 'Out' }}
            />
          </div>
        </div>
        <div className={classes.container__content__row}>
          <p>ID подразделения во внешней системе</p>
          <div className={classes.container__content__row__radio}>
            <Radio
              checked={checked}
              onChange={() => setChecked(!checked)}
              value="out"
              name="radio-button-demo"
              inputProps={{ 'aria-label': 'Out' }}
            />
          </div>
        </div>
        <div className={classes.container__content__row}>
          <p>ID руководителя во внешней системе</p>
          <div className={classes.container__content__row__radio}>
            <Radio
              checked={checked}
              onChange={() => setChecked(!checked)}
              value="out"
              name="radio-button-demo"
              inputProps={{ 'aria-label': 'Out' }}
            />
          </div>
        </div>
        <div className={classes.container__content__row}>
          <p>ID родительского подразделения во внешней системе</p>
          <div className={classes.container__content__row__radio}>
            <Radio
              checked={checked}
              onChange={() => setChecked(!checked)}
              value="out"
              name="radio-button-demo"
              inputProps={{ 'aria-label': 'Out' }}
            />
          </div>
        </div>
        <div className={classes.container__content__row}>
          <p>ID организации во внешней системе</p>
          <div className={classes.container__content__row__radio}>
            <Radio
              checked={checked}
              onChange={() => setChecked(!checked)}
              value="out"
              name="radio-button-demo"
              inputProps={{ 'aria-label': 'Out' }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
